RemoveUserController.$inject = ['$scope', '$uibModalInstance', 'Member',
  'selectedMember', 'CurrentCustomer', 'CurrentUser', '$window'
]

export default function RemoveUserController($scope, $uibModalInstance,
  Member, selectedMember, CurrentCustomer, CurrentUser, $window) {

  $scope.busy = false;
  $scope.selectedMember = selectedMember;
  $scope.removeMember = () => {

    if (selectedMember.id === CurrentUser.data.id && !$window.confirm(
        "Are you sure you want to remove yourself?")) {
      // prevent user self-removal
      return;
    }
    var toRemove = new Member(selectedMember);
    toRemove.api.remove().then(data => {

      if (CurrentUser.data.id === selectedMember.id) {
        $window.location.reload();
      } else {
        CurrentCustomer.setProp('users', data);
        $scope.$close()
      }
    });
  };
}



// WEBPACK FOOTER //
// ./project/modals/remove-user/remove-user.controller.js